import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../_services/auth/authentication.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Authentication, CurrentUser, PenggunaModel, Token } from '../../_model/auth/authentication.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SkpdService } from "../shared/skpd.service";
import { SkpdModel } from "../shared/skpd.model";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss']
})
export class LoginComponent implements OnInit {

  formGroup: FormGroup;
  private user: Authentication;
  passwordFieldType: string = 'password';

  constructor(
    private router: Router,
    private _formBuilder: FormBuilder,
    private _authService: AuthenticationService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService) {
    this.formGroup = this._formBuilder.group({
      username: this._formBuilder.control('', [
        Validators.required,
        Validators.pattern('^[0-9]*$')
      ]),
      password: this._formBuilder.control('', [Validators.required]),
      captcha: this._formBuilder.control('', [Validators.required])
    });
  }

  ngOnInit(): void {
    localStorage.clear();
    const currentYear = new Date().getFullYear();
    localStorage.setItem('defaultYear', currentYear.toString());
    localStorage.setItem('tahunAnggaran', currentYear.toString());
    localStorage.setItem('tahunAnggaranNext', (currentYear + 1).toString());
    localStorage.setItem('tahunAnggaranPrevious', (currentYear - 1).toString());

    this.randomCaptcha(5);
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  login() {
    if (!this.checkCaptcha()) {
      this.user = this.formGroup.value;
      this.spinner.show();
      this._authService.login(this.user).subscribe(response => {
        const token: Token = response.body;
        this._authService.setToken(token);
        let pengguna: CurrentUser = this._authService.currentUser;
        if (Number(pengguna.pengguna.otor) < 3) {
          this.spinner.show();
          this._authService.getSkpd(pengguna.pengguna.skpdId).subscribe(response2 => {
            localStorage.setItem('skpdDetail', JSON.stringify(response2));
            this.toastr.success('Berhasil Login', 'Berhasil', {
              closeButton: true
            })
            this.spinner.hide();
            this.router.navigate(['/']).then(() => {

            })
          })
        } else {
          let emptySkpd: SkpdModel = new SkpdModel();
          emptySkpd.id = -1;
          localStorage.setItem('skpdDetail', JSON.stringify(emptySkpd));
          this.toastr.success('Berhasil Login', 'Berhasil', {
            closeButton: true
          })
          this.spinner.hide();
          this.router.navigate(['/']).then(() => {
            // window.location.reload();
          })
        }
      }, error => {
        if (error.status === 400) {
          this.toastr.error('Username & Password Salah', 'Gagal', {
            closeButton: true
          })
          this.spinner.hide();
        }
      });
    } else {
      this.toastr.warning('Captcha Tidak sesuai', 'Peringatan', {
        closeButton: true
      })
    }
  }

  captchaValue = '';

  randomCaptcha(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 6; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    if (this.captchaValue) {
      this.formGroup.controls['captcha'].setErrors({ 'match': true });
    }
    this.captchaValue = result;
  }

  checkCaptcha(): boolean {
    return !((this.formGroup.get('captcha').value === this.captchaValue) && this.formGroup.get('captcha').value.length >= 5);
  }

  togglePasswordVisibility() {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  }
}